import React, { useContext, useState } from "react";
import { useQuery } from "@apollo/client";
import {
  GET_COMPETITIONS,
  COMPETITIONS_WITH_PERMISSION,
} from "../../GraphQL/Competitions.js";
import LoadingSpinner from "../../Components/UI/LoadingSpinner.js";
import PageError from "../../Components/UI/PageError.js";
import PageLayout from "../../Components/UI/PageLayout.js";
import CompetitionsTable from "../../Components/Competition/CompetitionsTable.js";
import NewCompetitionButton from "../../Components/Competition/NewCompetitionButton.js";
import NewCompetitionDialog from "../../Components/Competition/NewCompetitionDialog.js";
import PageFAB from "../../Components/UI/PageFAB.js";
import { LoginContext } from "../../Components/Login/LoginContext";

const CompetitionsPage = () => {
  const competitions = useQuery(GET_COMPETITIONS, {});
  const competitionsWithPermission = useQuery(COMPETITIONS_WITH_PERMISSION, {});
  const [auth] = useContext(LoginContext);
  const [fabOpen, setFabOpen] = useState(false);

  const queryError = competitions.error || competitionsWithPermission.error;
  if (queryError) {
    return (
      <PageError
        message={queryError.message}
        onRetry={() => {
          competitions.refetch();
          competitionsWithPermission.refetch();
        }}
      />
    );
  }

  if (competitions.loading || competitionsWithPermission.loading)
    return <LoadingSpinner />;

  return (
    <PageLayout
      title="Competitions"
      breadcrumbs={[{ label: "Home", to: "/" }, { label: "Competitions" }]}
      actions={auth.loggedIn && <NewCompetitionButton />}
    >
      <CompetitionsTable
        competitionsWithPermission={
          competitionsWithPermission.data.competitionsWithPermission
        }
        competitions={competitions.data.competitions}
      />
      {auth.loggedIn && (
        <>
          <PageFAB label="Create Competition" onClick={() => setFabOpen(true)} />
          <NewCompetitionDialog open={fabOpen} setOpen={setFabOpen} />
        </>
      )}
    </PageLayout>
  );
};

export default CompetitionsPage;
